import GameViewDesktop from './GameViewDesktop';
import GameViewMobile from './GameViewMobile';
import useChangeCurrencyNotification from './hooks/useChangeCurrencyNotification';
import useGameView from './useGameView';
import useGame from '../hooks/useGame';

type Props = {
  freebetNotification: {
    title: string;
    rewardCurrencyIcon: string;
    walletCurrency: string;
    isRequiredToSwitch: boolean;
    isGameCurrencyChangeEnabled: boolean;
    translations: Record<string, string>;
    rewardId: string;
  };
};

const GameView: FC<Props> = ({ freebetNotification }) => {
  useChangeCurrencyNotification(freebetNotification);
  const { isDesktop } = useGameView();
  const { isGameBlocked } = useGame();

  if (isGameBlocked) {
    return null;
  }

  if (isDesktop) {
    return <GameViewDesktop />;
  }
  return <GameViewMobile />;
};

export default GameView;
